import { cardAt, posOf } from './_shared';

const FACE_DOWN_DEF = Object.freeze({ faceUp: false, defense: true });
const FACE_UP_ATK = Object.freeze({ faceUp: true, defense: false });

/**
 * **反転召喚（宣言）**（Issue #589）。分岐は無い。事実: `prevPosition`（開く前。盤面の前の姿。すでに表なら裏に倒す）/
 * `position`（開いたあと）/ `code`。uid が無ければ null
 */
export default Object.freeze({
  event: 'flipsummoning',
  label: '反転召喚（宣言）',
  variants: Object.freeze([]),
  classify({ payload, board, boardBefore }) {
    if (!payload?.uid) return null;
    const before = cardAt(boardBefore, payload.uid, null);
    const after = cardAt(board, payload.uid, null);
    const prev = posOf(before) ?? FACE_DOWN_DEF;
    const next = payload.position ?? posOf(after) ?? FACE_UP_ATK;
    return {
      ...payload,
      prevPosition: prev.faceUp ? { ...prev, faceUp: false } : prev,
      position: next,
      code: payload.code ?? after?.code ?? null,
    };
  },
});
